/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Exact_Alarm_DismissInputs */

const en_us2_offline_exact_alarm_dismiss = /** @type {(inputs: Offline_Exact_Alarm_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not now`)
};

const pt_br2_offline_exact_alarm_dismiss = /** @type {(inputs: Offline_Exact_Alarm_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora não`)
};

const es_419_offline_exact_alarm_dismiss = /** @type {(inputs: Offline_Exact_Alarm_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora no`)
};

const pt_pt2_offline_exact_alarm_dismiss = /** @type {(inputs: Offline_Exact_Alarm_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora não`)
};

const fr_fr2_offline_exact_alarm_dismiss = /** @type {(inputs: Offline_Exact_Alarm_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus tard`)
};

const de_de2_offline_exact_alarm_dismiss = /** @type {(inputs: Offline_Exact_Alarm_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht jetzt`)
};

const it_it2_offline_exact_alarm_dismiss = /** @type {(inputs: Offline_Exact_Alarm_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non ora`)
};

/**
* | output |
* | --- |
* | "Not now" |
*
* @param {Offline_Exact_Alarm_DismissInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_exact_alarm_dismiss = /** @type {((inputs?: Offline_Exact_Alarm_DismissInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Exact_Alarm_DismissInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_exact_alarm_dismiss(inputs)
	if (locale === "es-419") return es_419_offline_exact_alarm_dismiss(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_exact_alarm_dismiss(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_exact_alarm_dismiss(inputs)
	if (locale === "de-DE") return de_de2_offline_exact_alarm_dismiss(inputs)
	if (locale === "it-IT") return it_it2_offline_exact_alarm_dismiss(inputs)
	return en_us2_offline_exact_alarm_dismiss(inputs)
});
export { offline_exact_alarm_dismiss as "offline.exact_alarm_dismiss" }